import { useLingui } from '@lingui/react/macro';

import { cn } from '@/shared/lib/cn';

/** Compact app-navigation signal for background work owned by a routed feature. */
export function NavigationActivityIndicator({
  count,
  expanded,
}: {
  count: number;
  expanded: boolean;
}) {
  const { t } = useLingui();
  const label = t`${count} active transfers`;

  if (expanded) {
    return (
      <span
        className="ml-auto inline-flex min-w-5 shrink-0 items-center justify-center gap-1 rounded-full bg-primary/10 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-primary"
        aria-label={label}
      >
        <span className="size-1.5 animate-pulse rounded-full bg-primary" aria-hidden="true" />
        {count}
      </span>
    );
  }

  return (
    <span
      className={cn(
        'absolute right-1 top-1 size-2 rounded-full bg-primary',
        'ring-2 ring-sidebar-background',
      )}
      aria-label={label}
    />
  );
}
